import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { usePermissions } from "../context/PermissionsContext";
import Navbar from "./Navbar"; // Import Navbar
import "./Sidebar.css";
import {
  FaUser,
  FaUsers,
  FaUserTie,
  FaIdCard,
  FaSitemap,
  FaChartLine,
  FaExchangeAlt,
  FaCreditCard,
  FaTicketAlt,
  FaUserCog,
  FaKey,
  FaBuilding,
  FaTasks,
  FaCogs,
  FaEnvelope,
  FaTools,
  FaHistory,
  FaSignOutAlt,
  FaChartPie,
} from "react-icons/fa";

const menuItems = [
  // { name: "Profile", icon: <FaUser />, path: "/profile" },
  { name: "Clients", icon: <FaUsers />, path: "/clients" },
  { name: "Trading Accounts", icon: <FaChartLine />, path: "/trading-accounts" },
  // { name: "Deposits", icon: <FaUsers />, path: "/deposits" },
    { name: "KYC Documents", icon: <FaIdCard />, path: "/kyc-documents" },
  // { name: "Referral Tree", icon: <FaSitemap />, path: "/referral-tree" },
  { name: "Trade Report", icon: <FaChartLine />, path: "/trade-report" },
  {
    name: "IB",
    icon: <FaUserTie />,
    children: [
         { name: "IB Clients", path: "/ib-clients" },
      { name: "IB Referral Tree", path: "/referral-tree" },
      { name: "IB Commissions Settings", path: "/ib-commission" },
      { name: "IB Commission History", path: "/ib-commission-history" },
      { name: "IB Commission Withdrawal History", path: "/ib-withdraw-history" },
      { name: "IB Rewards", path: "/ib-rewards" },
      { name: "Rank Management", path: "/rank-management" },
    ],
  },

  {
    name: "PAMM",
    icon: <FaChartPie />,
    children: [
      { name: "Total PAMM Clients", path: "/pamm-clients" },
      { name: "Total PAMM Active Accounts", path: "/pamm-active-accounts" },
      { name: "PAMM Referral Tree", path: "/pamm-referral-tree" },
      { name: "PAMM Commission Report", path: "/pamm-commission-report" },
      { name: "PAMM Commission Settings", path: "/pamm-commission-settings" },
      { name: "PAMM Withdrawal History", path: "/pamm-withdrawal-history" },
      { name: "PAMM Accept Withdrawal History", path: "/pamm-withdrawal-history" },
      { name: "PAMM Rejected Withdrawal History", path: "/pamm-withdrawal-history" },
    ],
  },
  {
    name: "Copy Trading",
    icon: <FaExchangeAlt />,
    children: [
      { name: "Copy Trading Accounts", path: "/copy-trading-accounts" },
      { name: "Pending  Master Accounts", path: "/pending-accounts" },
      { name: "Master Account", path: "/approved-accounts" },
      { name: "Rejected Master Account", path: "/rejected-master-accounts" },
      // { name: "Approved Accounts", path: "/approved-accounts" },
      { name: "Approved Followers", path: "/approved-followers" },
      { name: "Rejected Followers", path: "/rejected-followers" },
      { name: "Profit Sharing Data", path: "/profit-sharing-data" },
      { name: "Rebate Accounts", path: "/rebate-accounts" },
    ],
  },
  {
    name: "Transaction",
    icon: <FaExchangeAlt />,
    children: [
      { name: "Account Ledger", path: "/account-ledger" },
      { name: "Daily Inflow", path: "/daily-inflow" },
      { name: "Deposit History", path: "/deposit-history" },
      { name: "Withdrawal History", path: "/withdraw-history" },
      { name: "Internal Transfers", path: "/internal-transfer" },
      { name: "Credit In/Out", path: "/credit-in-out" },
      { name: "Rejected Deposits", path: "/rejected-deposits" },
      { name: "Rejected Withdrawals", path: "/rejected-withdrawals" },
      //    { name: "IB Commissions", path: "/ib-commission" },
      // { name: "IB Commission Requests", path: "/ib-commission-requests" },
    ],
  },
  {
    name: "Payment Methods",
    icon: <FaCreditCard />,
    children: [
      { name: "Payment Methods", path: "/payment-methods" },
      { name: "Payment Wallets", path: "/payment-ledger" },
      { name: "Payment Method History", path: "/payment-method-history" },
      // { name: "Cash Cards", path: "/cash-card" },
      // { name: "Coin Payments", path: "/coin-payment" },
    ],
  },
  {
    name: "Support Tickets",
    icon: <FaTicketAlt />,
    children: [
          { name: "Manage Ticket ", path: "/manage-priority" },
   
    ],
  },
  {
    name: "Manage Staff",
    icon: <FaUserCog />,
    children: [
      { name: "Create New Staff", path: "/new-staff" },
      { name: "All Staff", path: "/all-staff" },
    ],
  },
  {
    name: "Manage Roles",
    icon: <FaKey />,
    children: [
      { name: "Create New Role", path: "/new-role" },
      { name: "All User Role", path: "/all-role" },
    ],
  },
  {
    name: "Manage Departments",
    icon: <FaBuilding />,
    children: [
      { name: "Create New Department", path: "/new-department" },
      { name: "All Department", path: "/all-department" },
    ],
  },
  {
    name: "Accounts",
    icon: <FaTasks />,
    children: [
      { name: "Account Type", path: "/account-type" },
      { name: "Account Status", path: "/account-status" },
     
    ],
  },

  
  {
    name: "Log Activity",
    icon: <FaHistory />,
    children: [
      { name: "Admin Activity", path: "/admin-acct" },
      { name: "User Activity", path: "/user-acct" },
      { name: "All Log Activity", path: "/log-acct" },
    ],
  },
  { name: "Logout", icon: <FaSignOutAlt />, path: "/logout" },
];

export default function Sidebar({ children }) {
  const [isOpen, setIsOpen] = useState(true); // Sidebar state
  const [dropdownOpen, setDropdownOpen] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const { hasModuleAccess, hasPermission, accessType, role } = usePermissions();

  // Check if screen is mobile size
  useEffect(() => {
    const checkScreenSize = () => {
      const isMobileSize = window.innerWidth <= 768;
      setIsMobile(isMobileSize);
    };

    // Set initial state based on screen size
    const initialIsMobile = window.innerWidth <= 768;
    setIsMobile(initialIsMobile);
    setIsOpen(!initialIsMobile); // Open on desktop, closed on mobile initially

    // Only track screen size changes, don't auto-toggle sidebar
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile && isOpen) {
        const sidebar = document.querySelector('.sidebar');
        const toggleBtn = document.querySelector('.toggle-btn');
        
        if (sidebar && !sidebar.contains(event.target) && 
            toggleBtn && !toggleBtn.contains(event.target)) {
          setIsOpen(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobile, isOpen]);

  const handleLogout = () => {
    localStorage.removeItem('isAdminLoggedIn');
    localStorage.removeItem('adminData');
    localStorage.removeItem('userPermissions');
    window.location.reload(); // Force app to re-render and show login page
  };

  const toggleDropdown = (name) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  // Function to check if menu item should be shown based on permissions
  const shouldShowMenuItem = (item, parentModuleName = null) => {
    // Always show Logout
    if (item.name === 'Logout') {
      return true;
    }

    // If Administrator role or full access, show everything
    if (role === 'Administrator' || accessType === 'subAdmin' || accessType === 'full') {
      return true;
    }

    // Check specific permissions for Profile and Dashboard
    if (item.name === 'Profile') {
      return hasPermission('view_profile') || hasPermission('edit_profile');
    }

    if (item.name === 'Dashboard') {
      return hasPermission('view_dashboard');
    }

    // Map menu names to module names in permissions
    const moduleMap = {
      'Clients': 'Clients',
      'IB': 'IB Clients',
      'KYC Documents': 'KYC Documents',
      'Referral Tree': 'Referral Tree',
      'Trade Report': 'Trade Report',
      'PAMM': 'PAMM',
      'Copy Trading': 'Copy Trading',
      'Transaction': 'Transaction',
      'Payment Methods': 'Payment Methods',
      'Support Tickets': 'Support Tickets',
      'Manage Staff': 'Manage Staff',
      'Manage Roles': 'Manage Roles',
      'Manage Departments': 'Manage Departments',
      'Manage Status & Types': 'Status & Types',
      'App Settings': 'App Settings',
      'Mail Settings': 'Mail Settings',
      'Platform Settings': 'Platform Settings',
      'Log Activity': 'Log Activity',
    };

    const moduleName = moduleMap[item.name];
    if (moduleName) {
      const hasAccess = hasModuleAccess(moduleName);
      // Debug log for Transaction
      if (item.name === 'Transaction') {
        console.log('Transaction check:', {
          moduleName,
          hasAccess,
          role,
          accessType
        });
      }
      return hasAccess;
    }

    // If this is a child item (no direct module mapping), check parent's module
    // Child items inherit access from their parent module
    if (parentModuleName) {
      return hasModuleAccess(parentModuleName);
    }

    // If no module mapping found, hide it (don't show by default)
    return false;
  };

  // Filter menu items based on permissions
  const getFilteredMenuItems = () => {
    // Map menu names to module names for parent items
    const moduleMap = {
      'Clients': 'Clients',
      'IB': 'IB Clients',
      'KYC Documents': 'KYC Documents',
      'Referral Tree': 'Referral Tree',
      'Trade Report': 'Trade Report',
      'PAMM': 'PAMM',
      'Copy Trading': 'Copy Trading',
      'Transaction': 'Transaction',
      'Payment Methods': 'Payment Methods',
      'Support Tickets': 'Support Tickets',
      'Manage Staff': 'Manage Staff',
      'Manage Roles': 'Manage Roles',
      'Manage Departments': 'Manage Departments',
      'Manage Status & Types': 'Status & Types',
      'App Settings': 'App Settings',
      'Mail Settings': 'Mail Settings',
      'Platform Settings': 'Platform Settings',
      'Log Activity': 'Log Activity',
    };

    return menuItems.filter(item => {
      if (!shouldShowMenuItem(item)) {
        return false;
      }

      // If item has children, filter them too
      if (item.children) {
        const parentModuleName = moduleMap[item.name];
        const filteredChildren = item.children.filter(child => shouldShowMenuItem(child, parentModuleName));
        // Only show parent if it has visible children
        if (filteredChildren.length === 0) {
          return false;
        }
        // Update children with filtered list
        item.filteredChildren = filteredChildren;
      }

      return true;
    });
  };

  // Recursive renderer
  const renderMenuItem = (item, level = 0) => {
    if (item.children || item.filteredChildren) {
      const childrenToRender = item.filteredChildren || item.children;
      
      return (
        <>
          <div
            className={`dropdown-toggle ${dropdownOpen[item.name] ? "open" : ""}`}
            onClick={() => toggleDropdown(item.name)}
          >
            {item.icon && <span className="icon">{item.icon}</span>}
            {(isOpen || !isMobile) && <span className="text">{item.name}</span>}
            {(isOpen || !isMobile) && (
              <span className="arrow">
                {dropdownOpen[item.name] ? "▲" : "▼"}
              </span>
            )}
          </div>

          {dropdownOpen[item.name] && (
            <ul className={`submenu level-${level}`}>
              {childrenToRender.map((child) => (
                <li key={child.name}>{renderMenuItem(child, level + 1)}</li>
              ))}
            </ul>
          )}
        </>
      );
    }

    // Handle logout specially
    if (item.name === 'Logout') {
      return (
        <div
          className="menu-link logout-link"
          onClick={handleLogout}
          style={{ cursor: 'pointer' }}
        >
          {item.icon && <span className="icon">{item.icon}</span>}
          {(isOpen || !isMobile) && <span className="text">{item.name}</span>}
        </div>
      );
    }

    return (
      <NavLink
        to={item.path}
        className={({ isActive }) =>
          isActive ? "active menu-link" : "menu-link"
        }
      >
        {item.icon && <span className="icon">{item.icon}</span>}
        {(isOpen || !isMobile) && <span className="text">{item.name}</span>}
      </NavLink>
    );
  };

  return (
    <div className="layout">
      {/* Mobile backdrop overlay */}
      {isMobile && isOpen && (
        <div 
          className="sidebar-backdrop" 
          onClick={() => setIsOpen(false)}
        />
      )}
      
      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? "open" : "closed"} ${isMobile ? "mobile" : ""}`}>
        {/* Logo */}
        <div className="logo">
          <img 
            src={process.env.PUBLIC_URL + "/assets/images/image.png"}  
            alt="logo" 
            className={isOpen ? "logo-full" : "logo-small"}
          />
        </div>

        {/* Profile */}
        {(isOpen || !isMobile) && (
          <div className="profile1">
          <img 
            src={process.env.PUBLIC_URL + "/assets/images/avatar.jpg"}   // ✅ No need for ./ or ../
            alt="Admin Avatar" 
            className="avatar1"
          />
          <span className="role1">Admin</span>
        </div>
        
        
        
        
        
        )}

        {/* Scrollable Menu */}
        <div className="menu-container">
          <ul className="menu">
            {getFilteredMenuItems().map((item) => (
              <li key={item.name}>{renderMenuItem(item)}</li>
            ))}
          </ul>
        </div>
      </div>

      {/* Main content */}
      <div className={`content ${isOpen ? "expanded" : "collapsed"}`}>
        {/* Navbar inside content */}
        <Navbar isOpen={isOpen} setIsOpen={setIsOpen} />
        {children}
      </div>
    </div>
  );
}
